export default "__VITE_ASSET__D5Yd5R_U__"